
import { createClient } from '@supabase/supabase-js';

const getEnvVar = (key: string): string => {
  // Priority 1: Vite's import.meta.env (Standard for Vite apps)
  if (typeof import.meta !== 'undefined' && (import.meta as any).env?.[key]) {
    return (import.meta as any).env[key];
  }
  // Priority 2: process.env (Fallback for some environments)
  if (typeof process !== 'undefined' && process.env?.[key]) {
    return process.env[key];
  }
  return '';
};

// Ensure these match your actual project details in Supabase Dashboard
const rawUrl = getEnvVar('VITE_SUPABASE_URL') || 'https://xbmzppmojakpyevqnxvs.supabase.co';
// Remove trailing slash if present to prevent double slashes in API calls
export const SUPABASE_URL = rawUrl.endsWith('/') ? rawUrl.slice(0, -1) : rawUrl;
export const SUPABASE_KEY = getEnvVar('VITE_SUPABASE_ANON_KEY') || 'sb_publishable_MuRdFef_uAJSJ7JzLzLXeg_smKPVSkH';

const isValidUrl = (url: string) => {
  try {
    return url && url.startsWith('http');
  } catch {
    return false;
  }
};

export const supabase = (isValidUrl(SUPABASE_URL) && SUPABASE_KEY)
  ? createClient(SUPABASE_URL, SUPABASE_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'findily-auth-token',
        storage: window.localStorage
      },
      global: {
        headers: { 'x-application-name': 'findily-property-catalog' }
      }
    })
  : null;
